import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { combineLatest } from "rxjs";
import { OutsetaPlanService } from "../../mad-auth/outseta-plan.service";

@Injectable({
  providedIn: 'root'
})
export class MethodToValueAPIService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService,
    private outsetaPlanService: OutsetaPlanService
  ) {}

  private _fetch() {
    return this.http.get<{data: Array<{
      id: number,
      name: string,
      approaches_to_value: Array<{
        id: number
      }>
    }>}>(environment.baseApiUrl + `api/v2/${this.subdomainService.subDomain}/methods-to-value/listing`, {
      headers: this.authService.getAuthHeaders()
    }).pipe(
      map(response => response.data.map(item => ({...item, approaches_to_value: item.approaches_to_value.map(atv => atv.id)})))
    )
  }

  fetchListing() {
    return combineLatest([
      this._fetch(),
      this.outsetaPlanService.allowedMethods()
    ]).pipe(
      map(([items, allowedMethods]) => {
        if (!items) return []
        return items.filter(item => allowedMethods.includes(item.id))
      })
    )
  }
}